import { format } from 'date-fns';

export const formatCurrency = (number: number) => {
  return `${Number(number).toLocaleString('vi-VN')} VND`;
};

export const formatDate = (date: string | Date) => format(new Date(date), 'dd/MM/yyyy');
export const formatDateSQL = (date: string | Date) => format(new Date(date), 'yyyy-MM-dd');
export const formatDateTime = (date: string | Date) => format(new Date(date), 'hh:mm:ss dd/MM/yyyy');
export const formatDateTimeDB = (date: string | Date) => format(new Date(date), 'yyyy-MM-dd hh:mm:ss');

export const formatNumericalOrder = (index: number, page: number, size: number, pageStartZero?: boolean) => {
  return (pageStartZero ? page : page - 1) * size + index;
};

export const formatNumeric = (value: string) => {
  if (!value) return '';
  return Number(value).toLocaleString('vi-VN');
};

export const formatInputNumeric = (value: string) => {
  if (!value) return '';
  return Number(value.replaceAll('.', '')).toLocaleString('vi-VN');
};

export const convertToNum = (num?: string | number) => {
  if (!num) return '0';
  return String(num).replaceAll('.', '');
};
